module.exports = __webpack_public_path__ + "img/github_icon_black.fbeb1605.png";